import styled from 'styled-components'
import { PreviewProps } from './pdfPreview.types'

export const Preview = styled.div<PreviewProps>`
  height: 4.5rem;
  background-image: ${(props) => props?.thumbnailUrl && `url('${props.thumbnailUrl}')`};
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;

  border-top-right-radius: var(--border-radius-lg);
  border-top-left-radius: var(--border-radius-lg);
`

Preview.displayName = 'Preview'

export const Link = styled.a`
  text-decoration: none;
`

Link.displayName = 'Link'

export const DataFile = styled.div`
  height: 3.75rem;
`

DataFile.displayName = 'DataFile'

export const Container = styled.div`
  width: 16.75rem;
  margin-top: 0.375rem;
`

Container.displayName = 'Container'

export const TextFileName = styled.div`
  max-width: 12.313rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow-wrap: break-word;
`

TextFileName.displayName = 'TextFileName'
